// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"304":"9cafa23e","772":"5f00eec7"}[chunkId] + ".chunk.css";
};